export const LAYOUT_PREFERENCE_STORAGE_KEY = 'layoutPreference';
export const TABLET_MENU_OPEN_STORAGE_KEY = 'tabletMenuOpen';
export const TABLET_MENU_ITEM_STORAGE_KEY = 'tabletMenuItemId';
